import licenseModule from '../../license.module';

export default licenseModule.component('licenseDeactivateDynamicConfirmation', {
    template: require('./licenseDeactivateDynamicConfirmation.component.html'),
    controller: licenseDeactivateDynamicConfirmationComponent,
    bindings: {
        resolve: '<',
        close: '&'
    }
});

function licenseDeactivateDynamicConfirmationComponent() {
    var vm = this;
    vm.$onInit = function() {
        vm.data = vm.resolve.data;
    };

    vm.ok = function() {
        vm.close({ $value: 'ok' });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-deactivate-dynamic-confirmation/licenseDeactivateDynamicConfirmation.component.js